import { ContentCard } from './Cards';

const whyAlmaCoachData = [
  {
    title: 'Inspire Learners',
    icon: '/assets/icons/placement-drive/grouop-chat.png',
    value:
      'Teach and guide students using your experience and help them gain new skills, knowledge and develop strong fundamentals',
  },
  {
    title: 'Grow your network',
    icon: '/assets/icons/placement-drive/file-text-front-color.png',
    value:
      'Join a network of top engineers, product managers & subject matter experts from leading companies & institutions',
  },
  {
    title: 'Earn per session',
    icon: '/assets/icons/placement-drive/puzzle-dynamic-color 1.png',
    value:
      'Develop a high paying passive income stream. Earn fixed income per session and variable rewards as per your performance',
  },
  {
    title: 'Teach your way',
    icon: '/assets/icons/placement-drive/chat-bubble-dynamic-gradient.png',
    value:
      'Teach accoding to your schedule, prepare your own content and have control on how you coach',
  },
  {
    title: 'Accelerate Careers',
    icon: '/assets/icons/placement-drive/megaphone-front-color.png',
    value:
      'Advance careers and employability by helping students acquire skills and prepare for interviews',
  },
  {
    title: 'Invest in Ecosystem',
    icon: '/assets/icons/placement-drive/flag-dynamic-color 1.png',
    value: 'This is the best way to give back to the community and nurture the tech ecosystem',
  },
];
export default function WhyCoach() {
  return (
    <div className="my-10 flex flex-col items-center justify-center p-5 text-center lg:my-32 lg:text-left">
      <h2 className="heading-h2 my-2 mb-8">Why join AlmaBetter as a Coach</h2>
      <div className="grid grid-flow-row grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {whyAlmaCoachData.map((content, index) => (
          <ContentCard
            key={index}
            bgColor="bg-yellow-light"
            align="items-center"
            text="text-center"
            content={content}
            height="h-[45px]"
          />
        ))}
      </div>
    </div>
  );
}
